module.exports = __webpack_public_path__ + "img/21.090a330b.png";